import { ROUTES } from 'modules/navigation/enums/RoutesEnum';
import { useMutation } from 'react-query';
import { useHistory } from 'react-router-dom';
import { useToastContext } from 'shared/components/Toast/context/ToastContext';
import { userService } from 'shared/services/UserService';
import { ICreateUserCredentials } from '../interfaces/ICreateUser';

export const useUpdateUser = () => {
    const { showToast } = useToastContext();
    const { push } = useHistory();

    const { mutateAsync, isError, isLoading } = useMutation(
        (data: ICreateUserCredentials) => userService.updateUser(data),
        {
            onSuccess: () => {
                showToast('success', 'User updated.');
                push(ROUTES.ADMIN_DASHBOARD);
            },
            onError: (error: any) => {
                console.log('Error on login user - ', error?.detail);
                showToast('error', error?.detail);
            },
        }
    );

    return {
        mutateAsync,
        isLoading,
        error: {
            isError,
        },
    };
};
